/**
 * Protected Routes Configuration
 * Routes that require authentication
 */
import { lazy } from 'react';
import { PROTECTED_ROUTES } from './constants';

// Lazy load components
const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const AdminDashboardPage = lazy(() => import('@/pages/dashboard/admin/AdminDashboardPage'));
const MyCoursesPage = lazy(() => import('@/pages/dashboard/MyCoursesPage'));
const CourseLearningPage = lazy(() => import('@/pages/dashboard/CourseLearningPage'));

/**
 * Protected route configuration array
 */
export const protectedRoutes = [
  {
    path: PROTECTED_ROUTES.DASHBOARD,
    component: DashboardPage,
    name: 'Dashboard',
    index: true,
    meta: {
      title: 'Dashboard - VastuSindu',
      description: 'User dashboard',
      requiresAuth: true,
      roles: ['USER', 'INTERNAL', 'ADMIN'],
    },
  },
  {
    path: PROTECTED_ROUTES.ADMIN_DASHBOARD,
    component: AdminDashboardPage,
    name: 'Admin Dashboard',
    meta: {
      title: 'Admin Dashboard - VastuSindu',
      description: 'Administrative dashboard',
      requiresAuth: true,
      roles: ['ADMIN'],
    },
  },
  {
    path: PROTECTED_ROUTES.MY_COURSES,
    component: MyCoursesPage,
    name: 'My Courses',
    meta: {
      title: 'My Courses - VastuSindu',
      description: 'View your purchased courses',
      requiresAuth: true,
      roles: ['USER', 'INTERNAL', 'ADMIN'],
    },
  },
  {
    path: PROTECTED_ROUTES.LEARN_COURSE,
    component: CourseLearningPage,
    name: 'Learn Course',
    meta: {
      title: 'Learning Area - VastuSindu',
      description: 'Course learning area',
      requiresAuth: true,
      roles: ['USER', 'INTERNAL', 'ADMIN'],
    },
  },
  // Add more protected routes here
  // {
  //   path: PROTECTED_ROUTES.PROFILE,
  //   component: ProfilePage,
  //   name: 'Profile',
  //   meta: {
  //     title: 'Profile - VastuSindu',
  //     description: 'User profile',
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: PROTECTED_ROUTES.SETTINGS,
  //   component: SettingsPage,
  //   name: 'Settings',
  //   meta: {
  //     title: 'Settings - VastuSindu',
  //     description: 'Account settings',
  //     requiresAuth: true,
  //   },
  // },
];

export default protectedRoutes;
